import BaseDialog from "@/components/BaseDialog";

// 插入对比
export function diffInfoModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./diffModal.vue'),
        options: {
            top: '10vh',
            width: '80%',
            title: '插入比对',
            closeOnClickModal:false,
            closeOnPressEscape:false,
        },
        props,
        cbs,
    })
}

// 素材预览
export function prewModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./prewModal.vue'),
        options: {
            top: '10vh',
            width: '80%',
            title: '素材预览',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 素材选择
export function materialSelectModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./selectMaterialModal.vue'),
        options: {
            top: '10vh',
            width: '80%',
            title: '素材选择',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
